import * as React from "react";

import { SelectionItem } from "@replo/design-system/blocks/selection/SelectionItem";
import { Input } from "@replo/design-system/components/input/Input";
import { DEBUG_OPTIONS } from "@v2/features/debug/debugOptions";
import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { Search } from "lucide-react";
import z from "zod";

export const OptionsTab: React.FC = () => {
  const [searchTerm, setSearchTerm] = React.useState("");

  const options = DEBUG_OPTIONS.map((option) => {
    // biome-ignore lint/correctness/useHookAtTopLevel: This is safe because the loop is deterministic and hooks are called in the same order
    const [value, setValue] = useLocalStorageState(option.key, false, {
      schema: z.boolean(),
    });
    return { option, value, setValue };
  });

  const filteredOptions = React.useMemo(() => {
    if (!searchTerm) {
      return options;
    }
    const term = searchTerm.toLowerCase();
    return options.filter(({ option }) => {
      return (
        option.label.toLowerCase().includes(term) ||
        option.description.toLowerCase().includes(term)
      );
    });
  }, [searchTerm, options]);

  return (
    <div className="flex flex-col gap-2">
      <Input
        size="sm"
        placeholder="Search options..."
        value={searchTerm}
        autoFocus
        onChange={(e) => setSearchTerm(e.target.value)}
        endEnhancer={<Search className="size-3.5 text-muted" />}
      />
      <div className="flex flex-col gap-1">
        {filteredOptions.map(({ option, value, setValue }) => (
          <SelectionItem
            key={option.key}
            id={`debug-option-${option.key}`}
            type="switch"
            variant="outline"
            label={option.label}
            description={option.description}
            checked={value ?? false}
            onCheckedChange={() => setValue(!value)}
            UNSAFE_className="p-2 [&_[data-slot=field-label]]:text-xs [&_[data-slot=field-description]]:text-xs"
          />
        ))}
      </div>
    </div>
  );
};
